export class GetBuyerTradeDataTransactionsError extends Error {}
